import moment from 'moment-timezone';

// The follow-up window for a veteran who wants to review before signing
// (Nic 2026-10-27, replacing "24 to 48 hours from the call", which threw
// away most of tomorrow on an evening call): the next two work days, every
// slot. Tomorrow and the day after; a weekend day is skipped, so a Friday
// call offers Monday and Tuesday. Bounded in Central time like the slots.
const CT = 'America/Chicago';

export const REVIEW_DAYS = 2;

export const reviewWindowOf = (now = Date.now(), zone = CT) => {
  const days = [];
  const cursor = moment.tz(now, zone).startOf('day');
  while (days.length < REVIEW_DAYS) {
    cursor.add(1, 'day');
    if (cursor.day() === 0 || cursor.day() === 6) continue;
    days.push(cursor.clone());
  }
  return {
    fromMs: days[0].valueOf(),
    toMs: days[days.length - 1].clone().endOf('day').valueOf(),
    days: days.map((d) => d.format('YYYY-MM-DD')),
  };
};

export const reviewWindowLabel = (reason = '') =>
  /spouse/i.test(reason)
    ? 'The next 2 days. Book it for when both of them can be on the line.'
    : 'The next 2 days, so they review while it is fresh.';
